export default function ProfileIdentityChoiceIcon({ icon }) {
  if (icon === "couple") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none">
        <path
          d="M8.25 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15.75 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.75 19.25c.92-3.05 2.42-4.57 4.5-4.57s3.58 1.52 4.5 4.57M11.25 19.25c.92-3.05 2.42-4.57 4.5-4.57s3.58 1.52 4.5 4.57"
          stroke="currentColor"
          strokeWidth="1.65"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (icon === "homme") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none">
        <path
          d="M9.5 18a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM13 10l5.25-5.25M14.75 4.75h3.5v3.5"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (icon === "femme") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" fill="none">
        <path
          d="M12 12.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12 12.75v7M8.75 17h6.5"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none">
      <path
        d="M12 11.75a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM5.75 19c1.24-2.62 3.33-3.93 6.25-3.93S17.01 16.38 18.25 19"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
